module.exports = __webpack_public_path__ + "static/media/edit.6ddd4ce7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/edit.svg
// module id = 97
// module chunks = 0